/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import { connect } from "react-redux";
import Grid from "@mui/material/Grid";
import React, { Component, useEffect, useRef, useState } from "react";
import { withTranslation, Trans } from "react-i18next";
import classes from "./return.module.css";

import Link from "@mui/material/Link";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "../../../component/tabPanel";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "../../../component/button";
import Collapse from "@mui/material/Collapse";

import Input from "../../../component/inputpm";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import Tooltip from "@mui/material/Tooltip";
import PageviewIcon from "@mui/icons-material/Pageview";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import PrintIcon from "@mui/icons-material/Print";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import Loader from "../../../component/loader";
import IconButton from "@mui/material/IconButton";
import TableContainer from "@mui/material/TableContainer";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Draggable from "react-draggable";
import CloseIcon from "@mui/icons-material/Close";
// import { makeStyles } from '@mui/styles';

/*
Table used to display the Physical Products
for Exchange and Return of the item

Gets the list of all the FINISHED GOOD 
items in the Order.
*/
const PhysicalProducts = (props) => {
  const { t, i18n } = props;

  const [error, setError] = useState({
    key: "",
    show: false,
  });

  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [itemDetails, setOrderItemDetails] = useState({});
  const [returnExchangeData, setReturnExchangeData] = useState({});
  const [reason, setReturnReason] = useState("");
  const [openReturnDialog, setReturnDialog] = useState(false);
  const [returnItem, setReturnItem] = useState([]);
  const [optedReturnId, setSeletedReturn] = useState();
  const [expandBOM, setExpandBOM] = useState(false);
  const [encodedLabel, setEncodedLabel] = useState(false);
  const [shippingLabel, setPrintLabelDialog] = useState(false);

  // const useStyles = makeStyles({
  //     resizablePaper: {
  //         resize: 'both',
  //         overflow: 'auto',
  //         minWidth: 640,
  //         minHeight: 200,
  //         maxWidth: '90vw',
  //         maxHeight: '90vh',
  //         width: '60vw',
  //     }
  // });
  // const classess = useStyles();

  useEffect(() => {
    setOrderItemDetails(props.orderItemDetails);
    setLoading(false);
  }, []);

  const returnOrderItem = (
    e,
    index,
    itemIndex,
    productId,
    serialNumber,
    returnItemType,
    item,
  ) => {
    //when checked for item to return
    let details = [...props.orderItemDetails];
    if (e.target.checked) {
      props.returnExchangeData.push({
        sku: "", //TODO: passed for testing
        quantity: "1",
        productId: productId,
        serialNumber: serialNumber,
        parentKitId:
          returnItemType == "BOM" ? item.id + "_" + item.serialNumber : "",
        //returnTypeId : returnTypeId
      });
      setReturnExchangeData(props.returnExchangeData);

      //check if a KIT is seleted.
      if (returnItemType === "KIT") {
        //Then mark all the items as checked
        details[index].returnExchange = e.target.checked;
        if (details && details.length > 0 && details[index].orderItems) {
          details[index].orderItems.map((item, i) => {
            if (!item.itemReturned) {
              item.returnExchange = e.target.checked;
            }
          });
        }

        //when a KIT, slice its raw material.
        props.returnExchangeData.map((product, i) => {
          if (
            product.parentKitId != "" &&
            product.parentKitId === productId + "_" + serialNumber
          ) {
            props.returnExchangeData.splice(i, 1);
            setReturnExchangeData(props.returnExchangeData);
          }
        });
      } else {
        details[index].orderItems[itemIndex].returnExchange = e.target.checked;
      }
    }
    //when unchecked the checkbox seleted before to return
    else {
      props.returnExchangeData.map((product, i) => {
        if (
          productId === product.productId &&
          serialNumber === product.serialNumber
        ) {
          props.returnExchangeData.splice(i, 1);
          setReturnExchangeData(props.returnExchangeData);
        }
      });

      //check if a KIT is unselected.
      if (returnItemType === "KIT") {
        //Then mark all the items as checked
        details[index].returnExchange = false;
        if (details && details.length > 0 && details[index].orderItems) {
          details[index].orderItems.map((item, i) => {
            if (!item.itemReturned) {
              item.returnExchange = false;
            }
          });
        }
      } else {
        details[index].orderItems[itemIndex].returnExchange = e.target.checked;
      }
    }

    setOrderItemDetails(details);
  };

  const setReturnTypeId = (
    e,
    kitIndex,
    itemIndex,
    serialNumber,
    productId,
    type,
  ) => {
    props.returnExchangeData.map((returnData, i) => {
      if (
        productId === returnData.productId &&
        serialNumber === returnData.serialNumber
      ) {
        returnData.returnTypeId = e.target.value;
      }
    });
    setReturnExchangeData(props.returnExchangeData);
    //setReturnReason(e.target.value)
  };

  const exchangeItems = () => {
    //props.submitData(props.returnExchangeData)
  };

  const createReturn = () => {
    let validReturnType = true;
    //check if return type is not empty.
    props.returnExchangeData.map((returnData, i) => {
      if (returnData.returnTypeId === undefined) {
        validReturnType = false;
      }
    });
    props.submitData(props.returnExchangeData, itemDetails, validReturnType);
  };

  const viewReturnDetails = (returnId, item, index) => {
    setReturnDialog(true);
    setSeletedReturn(returnId);
    setReturnItem([...item]);
  };

  const printShipLabel = (returnId) => {
    setSeletedReturn(returnId);
    setLoading(true);
    let payLoad = {
      returnOrderId: returnId,
    };
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/CREATE_RETURN_SHIPPING_LABEL/endpoint`,
      payLoad,
    )
      .then((res) => {
        if (res.data.message === "success") {
          if (res.data.shipmentLabelResponse.encodedLabel) {
            setEncodedLabel(res.data.shipmentLabelResponse.encodedLabel);
            setPrintLabelDialog(true);
          }
          setLoading(false);
        }
      })
      .catch((e) => {
        props.setErrorMessage(e.response.data.message);
        setError(e.response.data.message);
        setLoading(false);
      });
  };

  const expandKit = (item, index, value) => {
    let details = [...props.orderItemDetails];
    details[index].expandItemRow = value;
    setOrderItemDetails(details);
  };

  return (
    <Grid container>
      {/* Order items in the order for return */}
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow className={classes.tableHead}>
              <TableCell>{t("Order Items")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody></TableBody>
        </Table>
        <Table className={classes.table} aria-label="simple table">
          {itemDetails && itemDetails.length > 0 && (
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "30px" }}></TableCell>
                <TableCell>
                  <Grid container spacing={1} alignItems="center">
                    <Grid
                      item
                      size={{
                        xs: 4,
                      }}
                    >
                      <div style={{ display: "table-row" }}>
                        <div
                          style={{
                            display: "table-cell",
                            verticalAlign: "middle",
                            width: "50px",
                            paddingRight: "8px",
                          }}
                        >
                          {t("RETURN")}
                        </div>
                        <div
                          style={{
                            display: "table-cell",
                            verticalAlign: "middle",
                          }}
                        >
                          {t("PRODUCT_NAME")}
                        </div>
                      </div>
                    </Grid>
                    <Grid
                      item
                      size={{
                        xs: 1,
                      }}
                    >
                      {t("PRODUCT_ID")}
                    </Grid>
                    <Grid
                      item
                      size={{
                        xs: 3,
                      }}
                    >
                      {t("SERIAL_NUMBER")}
                    </Grid>
                    <Grid
                      item
                      size={{
                        xs: 1,
                      }}
                    >
                      {t("STATUS")}
                    </Grid>
                    <Grid
                      item
                      size={{
                        xs: 1,
                      }}
                    >
                      {t("QUANTITY")}
                    </Grid>
                    <Grid
                      item
                      size={{
                        xs: 2,
                      }}
                    >
                      {t("RETURN_TYPE")}
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
            </TableHead>
          )}
          {itemDetails && itemDetails.length > 0 ? (
            <TableBody>
              {itemDetails &&
                itemDetails.map((item, index) => (
                  <React.Fragment key={index}>
                    <TableRow key={index} hover className={classes.rowClass}>
                      <TableCell>
                        {item.orderItems && item.orderItems.length > 0 && (
                          <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() =>
                              expandKit(item, index, !item.expandItemRow)
                            }
                          >
                            {item.expandItemRow ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}
                          </IconButton>
                        )}
                      </TableCell>
                      <TableCell>
                        <Grid container spacing={1} alignItems="center">
                          <Grid
                            item
                            size={{
                              xs: 4,
                            }}
                          >
                            <div style={{ display: "table-row" }}>
                              <div
                                style={{
                                  display: "table-cell",
                                  verticalAlign: "middle",
                                  width: "50px",
                                  paddingRight: "8px",
                                }}
                              >
                                <Tooltip title={t("RETURN_KIT")}>
                                  <FormControlLabel
                                    style={{ marginLeft: 0 }}
                                    control={
                                      <Checkbox
                                        color="primary"
                                        name={`returnExchange`}
                                        //value={item.returnExchange}
                                        checked={item.returnExchange}
                                        disabled={item.itemReturned}
                                        onChange={(event) =>
                                          returnOrderItem(
                                            event,
                                            index,
                                            "",
                                            item.id,
                                            item.serialNumber,
                                            "KIT",
                                            item,
                                          )
                                        }
                                      />
                                    }
                                  />
                                </Tooltip>
                              </div>
                              <div
                                style={{
                                  display: "table-cell",
                                  verticalAlign: "middle",
                                }}
                              >
                                {item.description}
                              </div>
                            </div>
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 1,
                            }}
                          >
                            {item.id ? item.id : ""}
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 3,
                            }}
                          >
                            {item.inventoryItemTypeId === "SERIALIZED_INV_ITEM"
                              ? item.serialNumber
                              : ""}
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 1,
                            }}
                          >
                            {item.itemReturned ? t("RETURNED") : t("ACTIVE")}
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 1,
                            }}
                          >
                            <Input
                              divClass={classes.customDiv}
                              value="1"
                              style={{ width: "60px" }}
                              name={"quantity"}
                              //onChange={event => onChange(event)}
                              variant={"outlined"}
                              size={"small"}
                              disabled={true}
                            />
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 2,
                            }}
                          >
                            <FormControl
                              variant="outlined"
                              className="custom-select-input"
                            >
                              <InputLabel htmlFor="returnTypeId">
                                {t("SELECT_RETURN_TYPE")}
                              </InputLabel>
                              <Select
                                label="Select return type"
                                native
                                value={item.returnTypeId}
                                inputProps={{
                                  name: "returnTypeId",
                                  id: "returnTypeId",
                                }}
                                disabled={
                                  item.itemReturned || !item.returnExchange
                                }
                                onChange={(event) =>
                                  setReturnTypeId(
                                    event,
                                    index,
                                    "",
                                    item.serialNumber,
                                    item.id,
                                    "KIT",
                                  )
                                }
                              >
                                {!item.itemReturned && (
                                  <option value="">
                                    {t("SELECT_RETURN_TYPE")}
                                  </option>
                                )}
                                <option value="RTN_CHG_MIND">
                                  {t("RETURN")}
                                </option>
                                <option value="RTN_DAMANGE">
                                  {t("DAMAGED")}
                                </option>
                                <option value="RTN_EOL">
                                  {t("END_OF_LIFE")}
                                </option>
                                <option value="RTN_SWAP">{t("SWAP")}</option>
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ border: 0 }}></TableCell>
                      <TableCell style={{ border: 0 }}>
                        <Collapse
                          in={item.expandItemRow}
                          timeout="auto"
                          unmountOnExit
                        >
                          {item.orderItems &&
                            item.orderItems.map((bom, i) => (
                              <Grid
                                key={i}
                                container
                                spacing={1}
                                alignItems="center"
                                style={{
                                  paddingTop: i > 0 ? "10px" : "",
                                  borderBottom:
                                    "1px solid rgba(224, 224, 224, 1)",
                                  paddingBottom: "10px",
                                }}
                              >
                                <Grid
                                  item
                                  size={{
                                    xs: 4,
                                  }}
                                >
                                  <div style={{ display: "table-row" }}>
                                    <div
                                      style={{
                                        width: "25px",
                                        height: "10px",
                                        display: "table-cell",
                                      }}
                                    ></div>
                                    <div
                                      style={{
                                        display: "table-cell",
                                        verticalAlign: "middle",
                                        width: "50px",
                                        paddingRight: "8px",
                                      }}
                                    >
                                      <Tooltip title={t("RETURN_ITEM")}>
                                        <FormControlLabel
                                          style={{ marginLeft: 0 }}
                                          control={
                                            <Checkbox
                                              color="primary"
                                              name={`returnExchange`}
                                              //value={bom.returnExchange}
                                              disabled={
                                                item.returnExchange ||
                                                bom.itemReturned ||
                                                item.itemReturned
                                              }
                                              checked={bom.returnExchange}
                                              onChange={(event) =>
                                                returnOrderItem(
                                                  event,
                                                  index,
                                                  i,
                                                  bom.productId,
                                                  bom.serialNumber,
                                                  "BOM",
                                                  item,
                                                )
                                              }
                                            />
                                          }
                                        />
                                      </Tooltip>
                                    </div>
                                    <div
                                      style={{
                                        display: "table-cell",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      {bom.productName}
                                    </div>
                                  </div>
                                </Grid>
                                <Grid
                                  item
                                  size={{
                                    xs: 1,
                                  }}
                                >
                                  {bom.productId}
                                </Grid>
                                <Grid
                                  item
                                  size={{
                                    xs: 3,
                                  }}
                                >
                                  {bom.inventoryItemTypeId ===
                                  "SERIALIZED_INV_ITEM"
                                    ? bom.serialNumber
                                    : ""}
                                </Grid>
                                <Grid
                                  item
                                  size={{
                                    xs: 1,
                                  }}
                                >
                                  {bom.itemReturned || item.itemReturned
                                    ? t("RETURNED")
                                    : t("ACTIVE")}
                                </Grid>
                                <Grid
                                  item
                                  size={{
                                    xs: 1,
                                  }}
                                >
                                  <Input
                                    divClass={classes.customDiv}
                                    value="1"
                                    style={{ width: "60px" }}
                                    name={"quantity"}
                                    variant={"outlined"}
                                    size={"small"}
                                    disabled={true}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  size={{
                                    xs: 2,
                                  }}
                                >
                                  <FormControl
                                    variant="outlined"
                                    className="custom-select-input"
                                  >
                                    <InputLabel htmlFor="returnTypeId">
                                      {t("SELECT_RETURN_TYPE")}
                                    </InputLabel>
                                    <Select
                                      native
                                      label="Select return type"
                                      value={bom.returnTypeId}
                                      inputProps={{
                                        name: "returnTypeId",
                                        id: "returnTypeId",
                                      }}
                                      disabled={
                                        item.returnExchange ||
                                        bom.itemReturned ||
                                        item.itemReturned ||
                                        !bom.returnExchange
                                      }
                                      onChange={(event) =>
                                        setReturnTypeId(
                                          event,
                                          index,
                                          i,
                                          bom.serialNumber,
                                          bom.productId,
                                          "BOM",
                                        )
                                      }
                                    >
                                      <option value="">
                                        {t("SELECT_RETURN_TYPE")}
                                      </option>
                                      <option value="RTN_CHG_MIND">
                                        {t("RETURN")}
                                      </option>
                                      <option value="RTN_DAMANGE">
                                        {t("DAMAGED")}
                                      </option>
                                      <option value="RTN_EOL">
                                        {t("END_OF_LIFE")}
                                      </option>
                                      <option value="RTN_SWAP">
                                        {t("SWAP")}
                                      </option>
                                    </Select>
                                  </FormControl>
                                </Grid>
                              </Grid>
                            ))}
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell colSpan={2}>
                  <p align="center" style={{ margin: 0 }}>
                    {t("NO_DATA_AVAILABLE")}
                  </p>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
        {itemDetails && itemDetails.length > 0 && (
          <div>
            <div style={{ float: "left", width: "70%" }}>
              {error.show && (
                <span style={{ color: "#f44336", paddingLeft: "10px" }}>
                  {props.tabName} {error.key} is required.
                </span>
              )}
            </div>
            <div style={{ float: "right", width: "30%", textAlign: "right" }}>
              <Button
                className={classes.activateButton}
                onClick={() => {
                  createReturn();
                }}
                style={{ marginTop: "0", marginBottom: "10px" }}
              >
                {t("RETURN")}
              </Button>
            </div>
            <div style={{ clear: "both" }}></div>
          </div>
        )}
      </TableContainer>
      {/* Return Header and Items in the Order*/}
      <TableContainer component={Paper} style={{ marginTop: "30px" }}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow className={classes.tableHead}>
              <TableCell>{t("RETURNS")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody></TableBody>
        </Table>
        <Table className={classes.table} aria-label="simple table">
          {props.orderReturnList && props.orderReturnList.length > 0 && (
            <TableHead>
              <TableRow>
                <TableCell>{t("RMA_NUMBER")}</TableCell>
                <TableCell>{t("CREATED_ON")}</TableCell>
                <TableCell>{t("CREATED_BY")}</TableCell>
                <TableCell>{t("RETURN_STATUS")}</TableCell>
                <TableCell>{t("ACTION")}</TableCell>
              </TableRow>
            </TableHead>
          )}
          {props.orderReturnList && props.orderReturnList.length > 0 ? (
            <TableBody>
              {props.orderReturnList
                .sort((a, b) =>
                  a.returnId > b.returnId
                    ? 1
                    : b.returnId > a.returnId
                      ? -1
                      : 0,
                )
                .map((returnItem, index) => (
                  <TableRow
                    key={index}
                    hover
                    className={classes.rowClass}
                    onClick={() => {
                      viewReturnDetails(
                        returnItem.returnId,
                        returnItem.returnItems,
                        index,
                      );
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <TableCell>{returnItem.returnId}</TableCell>
                    <TableCell>{returnItem.createdOn}</TableCell>
                    <TableCell>{returnItem.createdBy}</TableCell>
                    <TableCell>{returnItem.returnStatus}</TableCell>
                    <TableCell>
                      <Tooltip title={t("VIEW_RETURN")}>
                        <PageviewIcon style={{ marginRight: "5px" }} />
                      </Tooltip>
                      <Tooltip title={t("PRINT_SHIPPING_LABEL")}>
                        <PrintIcon
                          onClick={(e) => {
                            e.stopPropagation();
                            printShipLabel(returnItem.returnId);
                          }}
                        />
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell colSpan={5}>
                  <p align="center" style={{ margin: 0 }}>
                    {t("NO_DATA_AVAILABLE")}
                  </p>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      {/* 
            <Button className={classes.activateButton} onClick={() => { navigate(`/order/${props.id}`) }}>{t('Back')}</Button>
            */}
      {/* Dialog to display returns */}
      <Dialog
        disableScrollLock={true}
        maxWidth={"md"}
        PaperComponent={DraggableDialogPaper}
        fullWidth={true}
        open={openReturnDialog}
        aria-labelledby="form-dialog-title"
        // PaperProps={{
        //     className: classess.resizablePaper
        // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "inline-flex", width: "95%" }}>
              {t("RETURN_ITEMS_FOR")} {optedReturnId}
            </span>
            <Tooltip title={t("CLOSE")}>
              <IconButton
                onTouchStart={() => setReturnDialog(false)}
                onClick={() => setReturnDialog(false)}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <Paper>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t("ITEM_NAME")}</TableCell>
                  <TableCell>{t("SERIAL_NUMBER")}</TableCell>
                  <TableCell>{t("RETURN_TYPE")}</TableCell>
                  <TableCell>{t("ITEM_QTY")}</TableCell>
                  <TableCell>{t("ITEM_PRICE")}</TableCell>
                  <TableCell>{t("RETURN_STATUS")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <React.Fragment>
                  {returnItem.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.itemName}</TableCell>
                      <TableCell>{item.serialNumber}</TableCell>
                      <TableCell>{item.returnType}</TableCell>
                      <TableCell>{parseFloat(item.returnQuantity)}</TableCell>
                      <TableCell>{item.returnPrice}</TableCell>
                      <TableCell>{item.status}</TableCell>
                    </TableRow>
                  ))}
                </React.Fragment>
              </TableBody>
            </Table>
          </Paper>
        </DialogContent>
        {/* <DialogActions>
                    <Button onClick={event => setReturnDialog(false)} color="primary">{t('CLOSE')}</Button>
                </DialogActions> */}
      </Dialog>
      {/* Dialog to print label */}
      <Dialog
        disableScrollLock={true}
        maxWidth={"md"}
        PaperComponent={DraggableDialogPaper}
        open={shippingLabel}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "inline-flex", width: "95%" }}>
              {t("SHIP_LABEL_FOR")} {optedReturnId}
            </span>
            <Tooltip title={t("CLOSE")}>
              <IconButton
                onTouchStart={() => setPrintLabelDialog(false)}
                onClick={() => setPrintLabelDialog(false)}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <Paper>
            <img
              height="650"
              width="600"
              src={`data:image/jpeg;base64,${encodedLabel}`}
            />
          </Paper>
        </DialogContent>
        {/* <DialogActions>
                    <Button onClick={event => setPrintLabelDialog(false)} color="primary">{t('CLOSE')}</Button>
                </DialogActions> */}
      </Dialog>
      <Loader loading={loading} />
    </Grid>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(
  withTranslation("translations")(PhysicalProducts),
);
